/* eslint-disable ember/classic-decorator-hooks, ember/no-computed-properties-in-native-classes */
import EmberObject, { computed } from '@ember/object';

import * as ArrayUtils from '../../utils/array';
import * as CommonUtils from '../../../utils/common';
import * as ConversionUtils from '../../utils/conversion';

export default class MagnitudDbResult extends EmberObject {
  specificationsInput;
  frequencyArray;
  magnitude;
  passbandFrequency;
  passbandAttenuation;
  stopbandFrequency;
  stopbandAttenuation;
  init() {
    if (!CommonUtils.isNullOrUndefined(this.specificationsInput)) {
      this.passbandFrequency = this.specificationsInput.passbandFrequency;
      this.passbandAttenuation = this.specificationsInput.passbandAttenuation;
      this.stopbandFrequency = this.specificationsInput.stopbandFrequency;
      this.stopbandAttenuation = this.specificationsInput.stopbandAttenuation;
    }
  }

  @computed('frequencyArray', 'magnitude') get graphData() {
    var friendlyFrequencyArray = this.frequencyArray;
    var magnitudeArray = this.magnitude;
    var dbData = ConversionUtils.VVarrtoDBarr(magnitudeArray) || [];
    var result = ArrayUtils.joinArrays(friendlyFrequencyArray, dbData);
    return result;
  }
}
